const bubbledata = {
    "name": "Current Filter",
    "children": [
        // questions
        {
            "name": "value of question 1",
            "children":[
                // answers
                {
                    "name": "value of response q",
                    "students": 25
                },
                {
                    "name": "value of response x",
                    "students": 10
                },
                {
                    "name": "value of response y",
                    "students": 54
                },
                {
                    "name": "value of response z",
                    "students": 89
                }
            ]
        },
        {
            "name": "value of question 2",
            "children":[
                // answers
                {
                    "name": "value of response a",
                    "students": 90
                },
                {
                    "name": "value of response b",
                    "students": 24
                }
            ]
        },
        {
            "name": "value of question 3",
            "children":[
                // answers
                {
                    "name": "value of response m",
                    "students": 40
                }
            ]
        },
        {
            "name": "value of question 4",
            "children":[
                // answers
                {
                    "name": "value of response n",
                    "students": 77
                }
            ]
        },
    ]
}

export default bubbledata;



// WEBPACK FOOTER //
// ./src/assets/data/samplebubbledata.ts